// removed by extract-text-webpack-plugin
module.exports = {"container":"_216ctU6TnEQBx8twflyn7B","icon":"_1IFnBssuilgS8ZUUl1iwEE","title":"_3p3oqzqVruvcpRIeyKEM2Q","image":"_1rzAHbRtI8_wIETFbubvSe","csv":"q9vSlHYNzWWLlUFYi_tsm"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/Add/styles.css
// module id = 3187
// module chunks = 0